/**
 * Store data in localStorage with a given key.
 * @param key Key under which data should be stored.
 * @param data Data to be stored.
 */

import { getUniqueTimestamp } from '../getUniqueTimestamp'

export const tabId = () => {
    const tabId = sessionStorage.tabId ? sessionStorage.tabId : (sessionStorage.tabId = getUniqueTimestamp())
    return tabId
}
export function storeData(key: string, data: any): void {
    try {
        const serializedData = JSON.stringify(data)
        localStorage.setItem(tabId() + key, serializedData)
    } catch (error) {
        console.error('Failed to store data in localStorage:', error)
    }
}

/**
 * Retrieve data from localStorage using the key.
 * @param key Key under which data is stored.
 */
export function getData<T>(key: string): T | null {
    try {
        const serializedData = localStorage.getItem(tabId() + key)
        if (serializedData === null) {
            return null
        }
        return JSON.parse(serializedData) as T
    } catch (error) {
        console.error('Failed to retrieve data from localStorage:', error)
        return null
    }
}

/**
 * Check if a key exists in localStorage.
 * @param key Key to check.
 */
export function hasKey(key: string): boolean {
    return localStorage.getItem(tabId() + key) !== null
}

/**
 * Remove a specific key from localStorage.
 * @param key Key to remove.
 */
export function removeKey(key: string): void {
    localStorage.removeItem(tabId() + key)
}

/**
 * Clear all data from localStorage.
 */
export function clearAll(): void {
    localStorage.clear()
}

export const syncSelected = (selectedKey: string) => {
    if (hasKey(selectedKey)) {
        return getData<{ [key: string]: string }>(selectedKey)?.[selectedKey]
    } else {
        return null
    }
}
export const storeSelected = (selectedKey: string, selectedValue: string) => {
    storeData(selectedKey, { [selectedKey]: selectedValue })
}
